export default __webpack_public_path__ + "static/media/4.cfd0abc6.webp";